<template>
  <div class="UIRating">
    <div class="UIRating__icons">
      <img src="./assets/rating-logos.svg" alt="Rating" />
    </div>

    <div class="UIRating__stars">
      <div v-for="star in 5" :key="star" class="UIRating__star">★</div>
    </div>

    <div class="UIRating__score">
      {{ score }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  score: {
    type: String,
    default: '4.9',
  },
})
</script>

<style lang="scss" scoped>
.UIRating {
  display: flex;
  align-items: center;
  gap: 1rem;

  .UIRating__icons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .UIRating__stars {
    display: flex;
    align-items: center;
    gap: 0.125rem;
  }

  .UIRating__star {
    font-size: 1.5rem;
    color: #fbbf24;
  }

  .UIRating__score {
    font-size: 1rem;
    font-weight: 600;
    color: $color-ui-gray-cool-900;
  }
}
</style>
